import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';




@Injectable()
export class HomeService {

  politicianCollection: AngularFirestoreCollection<any>;
  partidosColletion: AngularFirestoreCollection<any>;

  politicians: Observable<any[]>;
  url: string;
  path: string;

  constructor(private afs: AngularFirestore) {
    this.politicianCollection = this.afs.collection('politicians', (ref) => ref.orderBy('percentile_Indicators', 'desc'));
    this.partidosColletion = this.afs.collection('political-parties', (ref) => ref.orderBy('name', 'asc'));

  }

 
  getPolitician(): Observable<any[]> {
    // ['added', 'modified', 'removed']
    return this.politicianCollection.snapshotChanges().pipe(
      map((actions) => {
        return actions.map((a) => {
          const data = a.payload.doc.data();
          return { id: a.payload.doc.id, ...data };
        });
      })
    );
  }


  getPartidos(): Observable<any[]> {
    return this.partidosColletion.snapshotChanges().pipe(
      map((actions) => {
        return actions.map((a) => {
          const data = a.payload.doc.data();
          return { id: a.payload.doc.id, ...data };
        });
      })
    );
  }




 

  getURL(url: string) {
    return this.url = url;
  }

  setURL() {
    return this.url;
  }

  setPath(path: string) {
    return this.path = path;
  }

  getPath() {
    return this.path;
    }

}
